
    import { useContext, useState }  from 'react'
    import GlobalContext from 'proj/contexts/global';
    import ClassNames from 'classnames';

    import * as Intro from './components';

    export default ( { ...props } ) =>
    {
        const { data, setActive, menuOpen, setMenuOpen } = useContext(GlobalContext);
        const { icon, copy, buttons, ...intro } = data?.intro || {};

        const onButtonClicked = e => 
        {
            const id = parseInt(e.currentTarget.dataset['id']);
            const action = buttons[id]?.action;
            
            switch(action)
            {
                case "sections" :
                    setActive(0);
                    break;
                
                case "take_me_there" :
                    setMenuOpen(!menuOpen)
                    break;

                default: break;
            }
        }
        
        const getButton = (val, id) =>
            <Intro.Button key={`button-${id}`} onClick={ onButtonClicked } data-id={ id }>
                <Intro.ButtonArrowIcon />
                <Intro.ButtonLabel text={ val.label } />
            </Intro.Button>

        return  <Intro.Content>
                    <Intro.Icon />
                    { copy && copy.map((val, id) => <Intro.Title key={`intro-${id}`} text={ val.value } /> ) }
                    <Intro.ButtonContainer>
                        { buttons && buttons.map(getButton) }
                    </Intro.ButtonContainer>
                </Intro.Content>
    }